export default "https://cdn-static.gokick.com/assets/efda86aac2f53028585758eeb3b3c0048c8387b3/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";